import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { CustomToaster } from '../BaseUI';
import FooterSection from '../Referral/Landing/FooterSection';
import HeaderSection from './HeaderSection';

const client = new QueryClient();

const Gift = () => {
  return (
    <QueryClientProvider client={client}>
      <CustomToaster />
      <HeaderSection />
      <FooterSection />
    </QueryClientProvider>
  );
};

export default Gift;
